import React from "react";

export default function Upsells() {
  return (
    <svg width="42" height="41" viewBox="0 0 42 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_di_1708_44098)">
        <g clip-path="url(#clip0_1708_44098)">
          <rect x="1" width="40" height="40" rx="12" fill="url(#paint0_linear_1708_44098)" />
          <g clip-path="url(#clip1_1708_44098)" filter="url(#filter1_dd_1708_44098)">
            <path d="M19.0008 23C19.0008 23.378 19.2718 23.698 19.6448 23.76L22.6858 24.267C24.0278 24.49 25.0008 25.64 25.0008 27C25.0008 28.654 23.6548 30 22.0008 30V32H20.0008V30C18.3468 30 17.0008 28.654 17.0008 27H19.0008C19.0008 27.551 19.4488 28 20.0008 28H22.0008C22.5528 28 23.0008 27.551 23.0008 27C23.0008 26.622 22.7298 26.302 22.3568 26.24L19.3158 25.733C17.9738 25.51 17.0008 24.36 17.0008 23C17.0008 21.346 18.3468 20 20.0008 20V18H22.0008V20C23.6548 20 25.0008 21.346 25.0008 23H23.0008C23.0008 22.449 22.5528 22 22.0008 22H20.0008C19.4488 22 19.0008 22.449 19.0008 23ZM33.0118 19.182L30.4148 16.586C29.6358 15.806 28.3658 15.806 27.5868 16.586L25.0098 19.163L26.4238 20.577L28.0008 19V32H30.0008V19L31.5978 20.596L33.0118 19.182ZM20.0008 11V16H22.0008V11L23.5978 12.596L25.0118 11.182L22.4148 8.58598C21.6358 7.80598 20.3658 7.80598 19.5868 8.58598L17.0098 11.163L18.4238 12.577L20.0008 11ZM17.0118 16.182L14.4148 13.586C13.6358 12.806 12.3658 12.806 11.5868 13.586L9.00977 16.163L10.4238 17.577L12.0008 16V32H14.0008V16L15.5978 17.596L17.0118 16.182Z" fill="url(#paint1_linear_1708_44098)" />
          </g>
        </g>
      </g>
      <defs>
        <filter id="filter0_di_1708_44098" x="0.5" y="0" width="41" height="41" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1708_44098" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1708_44098" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_1708_44098" />
        </filter>
        <filter id="filter1_dd_1708_44098" x="-21" y="-18.1015" width="84" height="84" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="10" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1708_44098" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="3.89851" />
          <feGaussianBlur stdDeviation="15" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_1708_44098" result="effect2_dropShadow_1708_44098" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1708_44098" result="shape" />
        </filter>
        <linearGradient id="paint0_linear_1708_44098" x1="21" y1="0" x2="21" y2="40" gradientUnits="userSpaceOnUse">
          <stop stop-color="#29282C" />
          <stop offset="1" stop-color="#100F11" />
        </linearGradient>
        <linearGradient id="paint1_linear_1708_44098" x1="8.82431" y1="3.06997" x2="26.245" y2="28.6077" gradientUnits="userSpaceOnUse">
          <stop stop-color="white" />
          <stop offset="1" stop-color="white" stop-opacity="0.65" />
        </linearGradient>
        <clipPath id="clip0_1708_44098">
          <rect x="1" width="40" height="40" rx="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_1708_44098">
          <rect width="24" height="24" fill="white" transform="translate(9 8)" />
        </clipPath>
      </defs>
    </svg>
  )
}